import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TabletModeService } from 'app/services/tablet-mode.service';

export const TabletSessionGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const tabletModeService = inject(TabletModeService);

  const enterpriseId = route.queryParamMap.get('enterpriseId');
  if (!enterpriseId) {
    return router.parseUrl('/sign-in');
  }

  if (!tabletModeService.canAccessTabletClock(enterpriseId)) {
    return router.createUrlTree(['/tablet/sign-in'], {
      queryParams: { enterpriseId },
    });
  }

  return true;
};
